import React from "react";

import Widget from "2g-widget";

import FixniPozadavkyBoxContent from "./FixniPozadavkyBoxContent";
import useFixniPozadavky from "./useFixniPozadavky";
import useMessages from "./i18n/useMessages";

export function FixniPozadavkyBox() {
  const params = useFixniPozadavky();
  const messages = useMessages();
  return (
    <Widget collapsable={false} title={messages.title()}>
      <FixniPozadavkyBoxContent {...params} />
    </Widget>
  );
}

FixniPozadavkyBox.propTypes = {};

export default React.memo(FixniPozadavkyBox);
